import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Popup from 'components/Common/Popup/Popup';
import { AvailablePopups } from 'store/app/types';
import getCurrentCategory from 'store/category/selector/getCurrentCategory';
import CategoryList from './CategoryList/CategoryList';
import styles from './SelectCategoryPopup.module.scss';

const SelectCategoryPopup = () => {
  const { t } = useTranslation();
  const categories = useSelector(getCurrentCategory)?.sidebarItems || [];
  return (
    <Popup
      popupId={AvailablePopups.selectCategoryPopup}
      title={t('txt_select_category')}
      applyButtonTitle={t('txt_close')}
    >
      <div className={styles.categoryList}>
        <CategoryList level={1} categories={categories} />
      </div>
    </Popup>
  );
};

export default SelectCategoryPopup;
